export const ItemTypes = {
  MAJOR: "major",
  COURSE_IN_PLAN: "course-in-plan",
  COURSE_IN_REQ: "course-in-req",
  COURSE_IN_DOCK: "course-in-dock",
  COURSE_IN_EXPAND: "course-in-expand",
  COURSE_IN_SEARCH: "course-in-search",
};
